import * as React from "react";
import {
  List,
  Datagrid,
  ListProps,
  DateField,
  FunctionField,
  TextField
} from "react-admin";
import Pagination from "../Components/Pagination";
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { TopToolbar } from 'react-admin'
import { Button } from '@material-ui/core'
import {UserIdentificationSearch} from './UserIdentificationSearch'

const status: any = {
    NEW: "جدید",
    PROCESSING: "در حال پردازش",
    PROCESSED_SUCCESS: "پردازش شده",
    PROCESSED_FAILED: "خطا در پردازش"
  }

export const UserIdentificationList = (props: ListProps): React.ReactElement => {
  const [filterList, setFilterList] = React.useState({
      campaign: { contains: '' }
  });
  const getFile = async(event:any,id:any)=>{
    event.preventDefault();
    event.stopPropagation();
    try {
      const res = await axiosWithAuthInterceptor({
          url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/userIdentificationLinkExcels/output/${id}`,
          method: 'GET',
          responseType: 'blob', 
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = res.headers['content-disposition']
          ? res.headers['content-disposition'].split('filename=')[1]
          : 'downloaded_file.xlsx';

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
  } catch (error) {
      console.error('Error', error);
  } 
  }
 
  return (
    <>   
      <UserIdentificationSearch filterList={filterList} setFilterList={setFilterList}/>
      <List
        {...props}
        bulkActionButtons={false}
        title={"لیست لینک های اختصاصی"}
        perPage={50}
        pagination={<Pagination />}
        sort={{ field: 'createdAt', order: 'DESC' }}
        filter={filterList}      
      >
        <Datagrid rowClick="edit">
          <TextField label="شناسه" source="id" />          
          <TextField label="کمپین" source="utmCampaign" />
          <TextField label="مدیوم" source="utmMedium" />
          <TextField label="سورس" source="utmSource" />
          <TextField label="سرویس" source="service" />
          <TextField label="نام فایل" source="uploadedFileName" />
          <FunctionField label="وضعیت" render={(record: any) => status[record.status]} />
          <DateField source="createdAt" label="تاریخ آپلود" showTime={true} locales="fa-IR" />
          <FunctionField label="لینک دانلود" render={(record: any) => {
            return (
                <>
                  { record.status === 'PROCESSED_SUCCESS' ? 
              
                    <Button    onClick={(event)=>getFile(event,record.id)}  color="primary">دانلود</Button>
              
                    : 
                    <p></p>
                  } 
                </>
              )
            }} />
        </Datagrid>
      </List>
    </>
  );
};
